// Card com cabeçalho em fundo suave (título à esquerda, ações à direita) — o "Quick Stats" /
// "All Orders" da referência. `bodyClassName` controla o padding do conteúdo (tabela usa p-0).
export const Panel = ({ title, subtitle, icon: Icon, actions, children, className = '', bodyClassName = 'p-4 sm:p-5' }) => (
  <section className={`flex flex-col overflow-hidden rounded-2xl border border-gray-200/70 bg-subtle ${className}`}>
    {(title || actions) && (
      <header className="flex flex-col gap-3 px-4 py-3.5 sm:flex-row sm:items-center sm:justify-between sm:px-5">
        <div className="flex min-w-0 items-center gap-2">
          {Icon && <Icon className="h-4 w-4 flex-shrink-0 text-gray-400" />}
          <div className="min-w-0">
            <h2 className="truncate text-[15px] font-semibold text-gray-900">{title}</h2>
            {subtitle && <p className="truncate text-xs text-gray-500">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </header>
    )}
    <div className={`flex-1 rounded-2xl border-t border-gray-200/70 bg-white ${bodyClassName}`}>{children}</div>
  </section>
);
